function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTwoPoints = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.61 99.37"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M869 1151.79a9.4 9.4 0 0 1-2.75-6.94 9.81 9.81 0 0 1 2.75-7 9.26 9.26 0 0 1 6.94-2.86 9.77 9.77 0 0 1 9.92 9.91 9.23 9.23 0 0 1-2.86 6.94 9.81 9.81 0 0 1-7.06 2.76 9.41 9.41 0 0 1-6.94-2.81Zm0 79.76a9.4 9.4 0 0 1-2.75-6.94 9.82 9.82 0 0 1 2.75-7 9.26 9.26 0 0 1 6.94-2.86 9.77 9.77 0 0 1 9.92 9.91 9.23 9.23 0 0 1-2.86 6.94 9.81 9.81 0 0 1-7.06 2.76 9.41 9.41 0 0 1-6.94-2.81Z",
  transform: "translate(-866.25 -1134.94)",
  style: {
    fill: "#3cc"
  }
}));

export default SvgTwoPoints;